module.exports = __webpack_public_path__ + "media/Video 3.760047ac.mp4";